import React from 'react';

const LoadingPlaceholder: React.FC = () => {
  // If you modify this loading placeholder, remember to also modify its Rails HTML counter-part
  // `app/views/events/partials/event_details_loading_ssr_html.html`
  // Both templates share the same CSS code
  return (
    <div
      className='event-details-placeholder-wrapper'
      data-testid='event-details-loading-placeholder'
    >
      <div className='placeholder-loading-header'></div>
      <div className='container'>
        <div className='row'>
          <div className='col-3'>
            <div className='placeholder-loading-about-title my-5'></div>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <div className='placeholder-loading-about-content my-5'></div>
          </div>
        </div>
      </div>
      <div className='placeholder-loading-agenda'></div>
      <div className='container'>
        <div className='row'>
          <div className='col-3'>
            <div className='placeholder-loading-speakers-title my-5'></div>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <div className='placeholder-loading-speakers-content my-5'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPlaceholder;
